import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import qs from 'qs';
import { createStructuredSelector } from 'reselect';
import Loader from 'components/Loader';
import {
  selectLandingData,
  selectAcquisitionVariables,
  selectUSEnglishResourceBundle,
  selectCanadaFrenchResourceBundle,
  selectCanadaEnglishResourceBundle,
} from 'containers/Landing/selectors';
import { resetShopDeliveryOrder } from 'containers/PrimoAccount/actions';
import { selectShopDeliveryOrder } from 'containers/PrimoAccount/selectors';
import {
  // getFeatureTour,
  fetchEntry,
  fetchVariables,
  fetchResourceBundles,
} from 'containers/Landing/actions';
import { fetchUserRegion } from 'containers/UserRegion/actions';
import {
  selectIsInitiated,
  selectIsFetching,
  selectIsAuthenticated,
} from 'containers/Authentication/selectors';
import { isSsr } from 'utils/ssrHelper';

const parseSearch = (search) => qs.parse(search, { ignoreQueryPrefix: true });

class RouteProvider extends Component {
  componentDidMount() {
    const search = parseSearch(this.props.location.search);
    const { postalCode: queryPostalCode } = search;
    const {
      isServersideRendering,
      acquisitionVariables,
      usEnglishResourceBundle,
      canadaFrenchResourceBundle,
      canadaEnglishResourceBundle,
    } = this.props;

    if (queryPostalCode && !this.props.isAuthenticated) {
      this.props.fetchUserRegion(queryPostalCode);
    }

    if (!isServersideRendering) {
      if (
        usEnglishResourceBundle &&
        canadaFrenchResourceBundle &&
        canadaEnglishResourceBundle
      ) {
        window.canadaFrenchResourceBundle = canadaFrenchResourceBundle;
        window.canadaEnglishResourceBundle = canadaEnglishResourceBundle;
        window.usEnglishResourceBundle = usEnglishResourceBundle;
      } else {
        this.props.fetchResourceBundles();
      }

      this.props.fetchEntry({
        entryId: 'XznAGn2qMYukyOBFrDdVC',
        key: 'primoTransitionBanner',
      });

      if (isEmpty(acquisitionVariables)) {
        // For now Acquisition and Self Serve will use the same variables
        this.props.fetchVariables({
          title: '5Yb812r4dC1Oc19T3UXS8m', // Acquisition > Landing > Variables
          brandTitle: '5coHCEQ6FD1ECzrYSD44kE', // Acquisition > Branded > Variables
          key: 'acquisitionVariables',
        });
      }

      /* Disabled as per CX-2113, could be enabled in future
      if (!localStorage.getItem('displayFeatureTour')) this.props.getFeatureTour();
      */
    }
  }

  componentDidUpdate() {
    const { location, isAuthenticated, shopDeliveryOrder } = this.props;

    if (location.pathname === '/callback') return;

    if (!shopDeliveryOrder) return;

    if (
      !location.pathname.startsWith('/account/products') &&
      !location.pathname.startsWith('/account/future-orders') &&
      isAuthenticated
    ) {
      this.props.resetShopDeliveryOrder();
    }
  }

  render() {
    const {
      authIsInitiated,
      authIsFetching,
      isServersideRendering,
    } = this.props;

    return (
      <Loader
        loading={!isServersideRendering && (!authIsInitiated || authIsFetching)}
      >
        {this.props.children}
      </Loader>
    );
  }
}

RouteProvider.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
  fetchUserRegion: PropTypes.func,
  authIsInitiated: PropTypes.bool.isRequired,
  authIsFetching: PropTypes.bool.isRequired,
  isServersideRendering: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  // getFeatureTour: PropTypes.func,
  resetShopDeliveryOrder: PropTypes.func,
  fetchEntry: PropTypes.func,
  fetchVariables: PropTypes.func,
  acquisitionVariables: PropTypes.array,
};

const selectIsSsr = () => () => isSsr();

const mapStateToProps = createStructuredSelector({
  site: selectLandingData(),
  authIsInitiated: selectIsInitiated(),
  authIsFetching: selectIsFetching(),
  isAuthenticated: selectIsAuthenticated(),
  isServersideRendering: selectIsSsr(),
  acquisitionVariables: selectAcquisitionVariables(),
  usEnglishResourceBundle: selectUSEnglishResourceBundle(),
  canadaFrenchResourceBundle: selectCanadaFrenchResourceBundle(),
  canadaEnglishResourceBundle: selectCanadaEnglishResourceBundle(),
  shopDeliveryOrder: selectShopDeliveryOrder(),
});

const mapDispatchToProps = {
  fetchUserRegion,
  // getFeatureTour,
  resetShopDeliveryOrder,
  fetchEntry,
  fetchVariables,
  fetchResourceBundles,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(RouteProvider);
